import { apiService } from "api/apiService";
import type { ClassroomGroupMeetingResource } from "api/generated";
import { groupMeetingFromDto } from "meetings/group-meeting/api/mappers";
import type {
  GroupMeeting,
  GroupMeetingDto,
} from "meetings/group-meeting/types";

export const fetchLessonClassGroupMeeting = async (
  scheduleId: string,
  signal?: AbortSignal,
): Promise<GroupMeeting> => {
  const url = `/api/my-lessongroups/${encodeURIComponent(scheduleId)}/group-meeting`;

  const { data } = await apiService.get<ClassroomGroupMeetingResource>(url, {
    signal,
  });

  return groupMeetingFromDto(data as unknown as GroupMeetingDto);
};
